// A place to keep your menu scripting (ex. toggling a mobile menu)
(function($){
	// Handle menu interactions
	$(".main-menu-toggle").click(function() {
		mainNav();
	});

	function mainNav() {
		$(".main-menu-toggle").toggleClass("cross");
		$("body").toggleClass("modal-open");
		$("#site-navigation").toggleClass("open");
	}

	//Drop-down menu
	$('li.dropdown').hoverIntent({
		over() {
			$(this).addClass('dropdown-menu-open');
		},
		out() {
			$(this).removeClass('dropdown-menu-open');
		},
		sensitivity: 5,
		timeout: 300
	});

	// language switcher dropdown - only open on click for breakpoint 'medium-large-screen-max'
	// first prevent the parent link from firing
	$('.wpml-ls-item.menu-item-has-children >a ').click(function(e) {
		var screenWidth = $(document).width();
		if (screenWidth < 1100) {
			e.preventDefault();
		}
	});
	// next toggle the class
	$('.wpml-ls-item.menu-item-has-children').click(function(e) {
		var screenWidth = $(document).width();
		if (screenWidth < 1100) {			
			$(this).toggleClass('dropdown-menu-open');
		}
	});


	// (just an example below change it to suit your needs)
	//Listen for menu clicks with anchors, to close the menu 
	$(document).on('click', '.menus.open li.current-menu-item a:not(.expand)', function() {
		mainNav();
	});
	
})(jQuery);
